import React, { useState, useEffect, useCallback, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import MyAuctionCard from "../../atoms/ListingCard/myAuctionCard";
import {
  getMyWishlist,
  updateWishlistItems,
} from "../../../store/slices/wishlist";
import Loader from "../../atoms/Loader";
import socket from "../../../utils/socket";
import GlobalContext from "../../../context/GlobalContext";
import { toast } from "react-toastify";

const WatchlistList = (props) => {
  const dispatch = useDispatch();
  const wishlist = useSelector((state) => state.wishlist?.wishListItems);
  const loading = useSelector((state) => state.wishlist?.loading);
  const { userDetails } = useContext(GlobalContext);

  useEffect(() => {
    dispatch(getMyWishlist());
  }, [dispatch]);

  const filteredWishlist = wishlist?.filter(
    (item) => item.market_status === "open",
  );

  const handlePropertyUpdate = useCallback(
    (data) => {
      if (!wishlist) return;

      const loggedInUserId = userDetails.get["id"]
        ? parseInt(userDetails.get["id"], 10)
        : null;

      const index = wishlist.findIndex(
        (item) => item.id === parseInt(data.productId, 10),
      );

      if (index === -1) return;

      // Get the current user's ID from the socket data
      const currentBidderId = parseInt(data.userId, 10);
      const outBidderId = parseInt(data.outbiddedUser, 10);

      // Check if the current logged-in user is the highest bidder
      const isUserHighestBidder = currentBidderId === loggedInUserId;
      const isOutBidder = outBidderId === loggedInUserId;

      if (isOutBidder) {
        toast.info("You are no longer the highest bidder", {
          preventDuplicate: true,
        });
      }

      if (isUserHighestBidder) {
        if (data.message) {
          toast.info(data.message, {
            preventDuplicate: true,
          });
        }
        toast.success("Bid placed successfully!", {
          preventDuplicate: true,
        });
      }

      const updatedWishlist = [...wishlist];
      const itemToUpdate = { ...updatedWishlist[index] };

      if (Number(data.belowFive) === 1) {
        itemToUpdate.date_closed = data.belowFiveIncrement;
      }

      updatedWishlist[index] = {
        ...itemToUpdate,
        bidcount: data.bidCount,
        bidCount: data.bidCount,
        wprice: data.wPrice,
      };

      dispatch(updateWishlistItems(updatedWishlist));
    },
    [wishlist, dispatch],
  );

  useEffect(() => {
    // Set up socket listener
    const handleBidAddTime = (data) => {
      handlePropertyUpdate(data);
    };

    socket.on("bidAddtime", handleBidAddTime);

    // Cleanup socket listener
    return () => {
      socket.off("bidAddtime", handleBidAddTime);
    };
  }, [handlePropertyUpdate]);

  return (
    <>
      {loading ? (
        <div className="loader-wrapper">
          <Loader />
        </div>
      ) : filteredWishlist?.length > 0 ? (
        filteredWishlist.map((item, index) => {
          return <MyAuctionCard item={item} key={index} action="wishlist" />;
        })
      ) : (
        <div className="card card-body text-center">
          No Watchlist Listings Found
        </div>
      )}
    </>
  );
};

export default WatchlistList;
